import React from 'react';
import Switch from "react-switch";
import PropTypes from 'prop-types';

import Box from "../../component/Box/Box";
import ProductTypeService from "../ProductTypeService";
import MeasureUnitSelector from "./MeasureUnitSelector";
import Notify from "../../services/Notify";
import Loading from "../../component/Loading/Loading";
import {Col, ControlLabel, FormGroup, Row} from "react-bootstrap";
import FormButtons from "../../component/Form/FormButtons";
import ProductTypeParamsTable from "./ProductTypeParamsTable";
import {InputWithLabel} from '../../component/Form/InputWithLabel';

class ProductTypeForm extends React.Component {

  productTypeService = new ProductTypeService();

  constructor(props) {
    super(props);
    this.state = {
      loading: null
    };
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.productTypeService.findById(id).then(
        data => this.setState(
          {loading: false, entity: data, active: data.active}),
        error => this.setState({loading: false, message: 'Error'})
          && Notify.error('Falha o buscar tipo de produto!', error)
      )
    }
  }

  submitForm() {
    const {entity, active} = this.state;
    const existingProductType = entity && entity.id;
    const ptVersion = entity && entity.version >= 0 ? entity.version : null;
    const productType = {
      id: existingProductType,
      description: this.description && this.description.trim(),
      reference: this.reference && this.reference.trim(),
      erpCode: this.erpCode && this.erpCode.trim(),
      unitType: this.measureUnit,
      friendlyName: this.friendlyName && this.friendlyName.trim(),
      category: this.category,
      params: this.params,
      active: active,
      version: ptVersion
    };
    this.setState({loading: true, message: 'Salvando...'});
    this.productTypeService.save(productType).then(
      () => {
        this.props.history.goBack();
        Notify.success('Tipo de produto salvo');
      },
      (error) => {
        Notify.error('Falha ao salvar tipo de produto:', error);
        this.setState({loading: false, entity, message: null});
      }
    );
  }

  handleActive = () => {
    const {active} = this.state;
    this.setState({
      active: !active
    });
  };

  render() {
    const {loading, entity, message} = this.state;
    if (loading) {
      return <Loading message={message}/>
    }
    return (
      <Box info>
        <form ref={form => (this.form = form)} onSubmit={event => {
          event.preventDefault();
          this.submitForm()
        }}>
          <Row>
            <Col md={6}>
              <InputWithLabel
                label="Nome"
                placeholder="Nome"
                required
                onChangeText={text => this.friendlyName = text}
                defaultValue={entity && entity.friendlyName}
              />
            </Col>
            <Col md={6}>
              <InputWithLabel
                label="Codigo de Referência"
                placeholder="Codigo de Referência"
                required
                onChangeText={text => this.reference = text}
                defaultValue={entity && entity.reference}
              />
            </Col>
            <Col md={6}>
              <InputWithLabel
                label="Código da integração"
                placeholder="Código da integração"
                onChangeText={text => this.erpCode = text}
                defaultValue={entity && entity.erpCode}
              />
            </Col>
            <Col md={6}>
              <InputWithLabel
                label="Descrição"
                placeholder="Descrição"
                required
                onChangeText={text => this.description = text}
                defaultValue={entity && entity.description}
              />
            </Col>
            <Col md={6}>
              <MeasureUnitSelector required={true} defaultValue={entity && entity.unitType} setValue={value => {
                this.measureUnit = value
              }}/>
            </Col>
          </Row>
          <FormGroup>
            <ControlLabel>Produto ativo</ControlLabel>
            <br/>
            <Switch
              width={70}
              checked={this.state.active}
              onChange={this.handleActive}
              onColor={'#00cfc3'}
            />
          </FormGroup>
          <ProductTypeParamsTable defaultValue={entity && entity.params}
                                  setValue={params => this.params = params}/>

          <FormButtons history={this.props.history}/>
        </form>
      </Box>
    );
  }
}

ProductTypeForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default ProductTypeForm;



// WEBPACK FOOTER //
// ./src/productType/component/ProductTypeForm.js